import type {
  CostForm_FixedCost,
  CostForm_FixedCostData,
} from './fixed-cost.fragment';
import type {
  CostForm_VariableCost,
  CostForm_VariableCostData,
} from './variable-cost.fragment';

export type CostForm_Cost = CostForm_FixedCost | CostForm_VariableCost;

export type CostForm_CostData =
  CostForm_FixedCostData | CostForm_VariableCostData;

// The amount of a fixed cost, or the value of a variable cost, is null when the user may not
// read the costs.
export const isCostValueConfidential = (cost: CostForm_CostData): boolean =>
  'amount' in cost ? cost.amount === null : cost.value === null;
